module.exports = {"340822100":"高河镇","340822101":"石牌镇","340822102":"月山镇","340822103":"马庙镇","340822104":"金拱镇","340822105":"茶岭镇","340822106":"公岭镇","340822107":"黄墩镇","340822108":"三桥镇","340822109":"小市镇","340822110":"黄龙镇","340822111":"平山镇","340822112":"腊树镇","340822113":"洪铺镇","340822114":"江镇镇","340822200":"凉亭乡","340822201":"石镜乡","340822202":"秀山乡","340822203":"清河乡","340822204":"雷埠乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340822.json
// module id = 1093
// module chunks = 0